/**
 * Allow user to toggle password hiding.
 * Default is hidden.
 */
export default function addFieldShowHide() {
  const form = document.querySelector('#user_session');
  const passwordToggle = form?.querySelector('.js-password-toggle');
  const passwordField = form?.querySelector('#user_session_password');

  if (passwordToggle && passwordField) {
    passwordToggle.addEventListener('imagetogglechange', (event) => {
      const newType = (event.detail.index === 0) ? 'password' : 'text';
      passwordField.type = newType;
    });
  }
}
